import { css, jsx } from '@emotion/core';
import { Select } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';

import Form from '@/src/shared/components/Form';
import { bp, colors } from '@/styles';

const { Option } = Select;

const styles = {
  selectContainer: css`
    width: 100%;
    margin: 1.6rem 0;
    @media ${bp.md} {
      max-width: 36.5rem;
    }
  `,
  select: css`
    width: 100%;
    .ant-select-selection {
      background-color: ${colors.accentGrayUltralight};
    }
  `,
};

const Dropdown = props => {
  const { form, info, currentInfo, onChange } = props;
  const {
    field,
    label,
    persist,
    options,
    optionId,
    optionDesc,
    formOverrides = {},
    isMailing,
  } = info;

  const { register } = useSelector(state => state);

  return (
    <div key={optionId} css={styles.selectContainer}>
      <Form.Item label={label}>
        {form.getFieldDecorator(field, {
          initialValue: register[field],
          ...formOverrides,
        })(
          <Select
            showSearch
            allowClear
            optionFilterProp="children"
            onChange={e => {
              onChange(field, e);
            }}
            css={styles.select}
            size="large"
            placeholder="Select"
            disabled={isMailing && register.isMailingAddressDisabled}
          >
            {options.map(option => (
              <Option key={`${field}-${optionId}`} value={option[optionId]}>
                {option[optionDesc]}
              </Option>
            ))}
          </Select>
        )}
      </Form.Item>
    </div>
  );
};

export default Dropdown;
